module.exports = __webpack_public_path__ + "static/media/arbre-marron.96d9cb76.png";